import React from 'react';
import { Box, Flex, IconV2, TextV2 } from '@withjoy/joykit';
import { Lock, WarningTriangle } from '@withjoy/joykit/icons';
import { getCurrencySymbolFromCurrencyCode } from '@shared/utils/currency/utils';
import { useCurrencyName } from '@shared/utils/currency/useCurrencyName';
import type { CurrencyDisplayFieldProps } from './CurrencyDisplayField.types';

export const CurrencyDisplayField: React.FC<CurrencyDisplayFieldProps> = ({ currencyCode, caption }) => {
  const getCurrencyName = useCurrencyName();

  return (
    <Flex
      as="output"
      alignItems="center"
      gap={4}
    >
      <Box
        position="relative"
        flex="0 0 auto"
      >
        <Flex
          alignItems="center"
          justifyContent="center"
          width="48px"
          height="48px"
          borderRadius="full"
          backgroundColor="mono3"
        >
          <TextV2
            typographyVariant="hed1"
            color="mono14"
          >
            {getCurrencySymbolFromCurrencyCode(currencyCode)}
          </TextV2>
        </Flex>
        <Flex
          position="absolute"
          right={0}
          bottom={0}
          alignItems="center"
          justifyContent="center"
          width="20px"
          height="20px"
          borderRadius="full"
          borderWidth="1px"
          borderStyle="solid"
          borderColor="mono4"
          backgroundColor="white"
        >
          <IconV2
            size={16}
            color="mono12"
          >
            <Lock />
          </IconV2>
        </Flex>
      </Box>
      <Flex
        flexDirection="column"
        gap={1}
        minWidth={0}
      >
        <TextV2
          typographyVariant="hed1"
          color="mono14"
        >
          {`${getCurrencyName(currencyCode)} (${currencyCode})`}
        </TextV2>
        {caption && (
          <Flex
            alignItems="flex-start"
            gap={1}
          >
            <IconV2
              size={16}
              color="mono10"
              flex="0 0 auto"
            >
              <WarningTriangle />
            </IconV2>
            <TextV2
              typographyVariant="label2"
              color="mono10"
            >
              {caption}
            </TextV2>
          </Flex>
        )}
      </Flex>
    </Flex>
  );
};
